import React, { useState } from 'react';
import {
  Card,
  CardContent,
  TextField,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../../redux/slices/notificationSlice';
import CustomButton from '../../../componentsII/Buttons';
import api from '../../../axios/api';

const AddUpdateRefrigerantTypeModal = ({ onClose, refetch, refrigerantId = null, initialData = null }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  // Form state
  const [formData, setFormData] = useState({
    refrigerantName: initialData?.refrigerant_name || '',
    formula: initialData?.formula || '',
  });

  const validate = (values) => {
    const newErrors = {};

    // Refrigerant Name validation
    if (!values.refrigerantName.trim()) {
      newErrors.refrigerantName = 'Refrigerant name is required';
    } else if (values.refrigerantName.length < 2) {
      newErrors.refrigerantName = 'Refrigerant name must be at least 2 characters';
    }

    // Formula validation
    if (!values.formula.trim()) {
      newErrors.formula = 'Formula is required';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        refrigerantId: refrigerantId || 0,
        ...formData
      };
      const response = await api.post('/admin/CreateUpdateRefrigerantType', payload);
      if (response.data.status === '200') {
        dispatch(showNotification({
          message: response.data.message,
          type: "success"
        }));
        onClose();
        refetch?.();
      } else {
        setErrors(prev => ({
          ...prev,
          general: response.data.message || 'Something went wrong'
        }));
      }
    } catch (error) {
      setErrors({ submit: error.message });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  return (
    <Card className="w-full mx-auto">
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="refrigerantName" className="text-sm font-medium">
              Refrigerant Name
            </label>
            <TextField
              size="small"
              id="refrigerantName"
              name="refrigerantName"
              value={formData.refrigerantName}
              onChange={handleInputChange}
              placeholder="Enter refrigerant name"
              disabled={isSubmitting}
              error={Boolean(errors.refrigerantName)}
              className={'w-full'}
            />
            {errors.refrigerantName && (
              <p className="text-sm text-red-500 mt-1">{errors.refrigerantName}</p>
            )}
          </div>

          <div className="space-y-2">
            <label htmlFor="formula" className="text-sm font-medium block">Formula</label>
            <TextField
              size='small'
              id="formula"
              name="formula"
              value={formData.formula}
              onChange={handleInputChange}
              placeholder="Enter formula"
              disabled={isSubmitting}
              error={Boolean(errors.formula)}
              className={'w-full'}
            />
            {errors.formula && (
              <p className="text-sm text-red-500 mt-1">{errors.formula}</p>
            )}
          </div>

          <div className="flex justify-end gap-4 pt-4">
            <CustomButton
              className="bg-gray-500 hover:bg-gray-700 text-white"
              text="Cancel"
              click={onClose}
            />
            <CustomButton
              className="bg-green-600 hover:bg-green-700 text-white"
              text={refrigerantId ? "Update" : "Submit"}
              type="submit"
              disabled={isSubmitting}
            />
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default AddUpdateRefrigerantTypeModal;